import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FormikValues, useFormikContext } from "formik";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";

import FileUploadButtonWithoutPreview from "../../../../../common/fileUploadButton/FileUploadButtonWithoutPreview";

import styles from "../../../../patient/styles.module.scss";
import FormStepTitle from "../../../../../common/form/Steps/FormStepTitle";
import { H5 } from "../../../../patient/styles";
import PatientAdmissionTitleAndInput from "../../../../patient/AddPatient/form/PatientAdmissionTitleAndInput";

const referralDocumentsInfo = [
  {
    id: 1,
    name: "referralDocuments",
    label: "Referral Documents",
  },
];

const ReferralRemarkAndNewDocuments = () => {
  const { id } = useParams();

  const { setFieldTouched, values, setFieldValue } =
    useFormikContext<FormikValues>();

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("isLowerIncomeBeneficiary", e.target.value);
  };

  useEffect(() => {
    setFieldTouched("referralDocuments", !!id);
    setFieldTouched("remark", !!id);
  }, [id, setFieldTouched]);

  return (
    <>
      <PatientAdmissionTitleAndInput
        title="Remark*"
        name="remark"
        placeholder="Remark"
      />

      <Box>
        <H5>Upload referral documents</H5>
        {referralDocumentsInfo?.map((idCard: any, index: number) => (
          <Box className={styles.mTopBottom20} key={index}>
            <p>{idCard?.description}</p>
            <FileUploadButtonWithoutPreview
              label={idCard?.label}
              index={index}
              name={"referralDocuments"}
              multiple
            />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default ReferralRemarkAndNewDocuments;
